module.exports = __webpack_public_path__ + "img/belfius.6e91856a.png";